// Regra da casa (feedback_campo_de_senha_tem_botao_de_ver): todo campo de
// senha nasce com botao de mostrar/ocultar. Comeca escondido; alternar troca
// so o atributo `type` do MESMO <input> (nao remonta, nao usa `key`), entao
// o navegador preserva valor, posicao do cursor e integracao com gerenciador
// de senha sozinho. Rotulo do botao muda de estado ("Mostrar senha" / "Ocultar
// senha") para leitor de tela; alcancavel por Tab; icone Lucide em rem.
import { forwardRef, useId, useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../../lib/utils";

export const PasswordField = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function PasswordField({ className, id, ...rest }, ref) {
    const [visible, setVisible] = useState(false);
    const autoId = useId();
    const inputId = id ?? autoId;
    return (
      <span style={{ position: "relative", display: "block", width: "100%" }}>
        <input
          ref={ref}
          id={inputId}
          type={visible ? "text" : "password"}
          className={cn("input", className)}
          style={{ paddingRight: "2.5rem" }}
          {...rest}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
          aria-pressed={visible}
          tabIndex={0}
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "100%",
            width: "2.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "transparent",
            border: 0,
            color: "var(--color-ink-2)",
            cursor: "pointer",
          }}
        >
          {visible ? <EyeOff className="icon" aria-hidden /> : <Eye className="icon" aria-hidden />}
        </button>
      </span>
    );
  },
);
